import {
  FETCH_DEVICE,
  FETCH_DEVICE_EVENTS,
  FETCH_DEVICE_EVENTS_AND_LOGS,
  CLEAR_DEVICE
} from '#action/types';
import { reduceDuplica, formatProjectEvents } from '#component/device/overview/helper';

const defaultState = {
  events: [],
  deviceLogs: [],
  settings: []
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_DEVICE:
      // TODO: remove `location`
      return {
        ...state,
        ...action.payload,
        location: action.payload.lastLocation
      };
    case FETCH_DEVICE_EVENTS:
      return { ...state, events: reduceDuplica(action.payload) };
    case FETCH_DEVICE_EVENTS_AND_LOGS:
      const { logs } = action.payload;
      const formattedLogs = formatProjectEvents(logs) ?? [];
      const merged = [...state.events, ...formattedLogs];
      return {
        ...state,
        events: merged.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
      };
    case CLEAR_DEVICE:
      return defaultState;
    default:
      return state;
  }
};
